export default __webpack_public_path__ + "static/media/logo-sm.1dbfa3ca.png";